import { useKratosSession } from "@saflib/ory-kratos-sdk";
import { useGetPartById } from "@vendata/power-up-sdk";
import { useRoute } from "vue-router";
import { ref, watch } from "vue";

export function useEditLoader() {
  const route = useRoute();
  const partId = ref("");

  watch(
    () => route.params.id,
    (id) => {
      partId.value =
        typeof id === "string" ? id : Array.isArray(id) ? (id[0] ?? "") : "";
    },
    { immediate: true },
  );

  return {
    sessionQuery: useKratosSession(),
    partQuery: useGetPartById({ id: partId }),
  };
}
